import { AxiosClient } from '@pole/client/agromarket'
import { CanceledError } from 'axios'
import { reduxStore } from '@/api/client/base'
import { getJwt } from '@/logic/auth/reducer'
import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'

const { isSsr } = ExecutionEnvironment
const { NODE_ENV } = process.env
const IS_DEV = NODE_ENV === 'development'

const ssrUrl = IS_DEV
  ? `http://${process.env.CUSTOM_ENV}-ms-inputs-catalog-backend.dev.poletech.io/api`
  : `http://ms-inputs-catalog-backend/api`

const baseURL = isSsr ? ssrUrl : '/api/ms-inputs-catalog-backend'

export const registerInputsCatalogAxiosClient = () => {
  AxiosClient.registerApi('inputs-catalog', { baseURL, timeout: Number(process.env.API_RESPONSE_TIMEOUT) || 60_000 })
}

export const inputsCatalogAxiosClient = AxiosClient.getClient({
  apiName: 'inputs-catalog',
  onRequest: config => {
    if (!reduxStore.store) return config

    const reduxToken = getJwt()(reduxStore.store?.getState?.())
    if (!config.headers.Authorization && !!reduxToken?.length) config.headers.Authorization = `Bearer ${reduxToken}`

    return config
  },
})

export * from './types'
export { CanceledError }
export default inputsCatalogAxiosClient
